import { gql } from "@apollo/client";

const GET_PAYMENT_METHODS = gql`
  query PaymentMethods {
    paymentMethods {
      id
      maskedPan
      expiration
    }
  }
`;

const GET_BILLING_INFO = gql`
  query BillingInfo {
    billingInfo {
      id
      firstName
      lastName
      address
      country
      countryId
      state
      stateId
      city
      cityId
      postCode
      phone
      email
      companyLegalName
      companyVatNumber
    }
  }
`;

const GET_COMPANY_BALANCE = gql`
query Query {
  companyBalance
}
`

const GET_COMPANY_WALLET_TRANSACTIONS = gql`
query CompanyWalletTransactions($type: [WalletTransactionType!], $dateInterval: DateInterval, $pagination: Pagination) {
  companyWalletTransactions(type: $type, dateInterval: $dateInterval, pagination: $pagination) {
    totalCount
    items {
      amount
      balanceAfter
      campaignId
      createdAt
      description
      id
      type
    }
  }
}
`

export { GET_PAYMENT_METHODS, GET_BILLING_INFO, GET_COMPANY_BALANCE, GET_COMPANY_WALLET_TRANSACTIONS };
